import { inject } from './inject';
import { PciProxyCardNumber as BasePciProxyCardNumber } from './PciProxyCardNumber';

export const PciProxyCardNumber = inject(BasePciProxyCardNumber);
